import { z } from 'zod';
import { PlayerIdSchema } from '../../ids';
import { PlayerSchema } from '../../models/player';
import { SessionSchema } from '../../models/session';
import { DEV_PREFIX, API_PREFIX, defineEndpoint } from '../endpoint';
import { SignedInSchema } from './auth';

/**
 * Local sign-in as a seeded character (development, bots, tests): opens a session of the
 * character's account with the character already chosen. Like any sign-in, it revokes the
 * account's previous session.
 */
export const createSession = defineEndpoint({
  method: 'POST',
  path: `${DEV_PREFIX}/sessions`,
  access: 'dev',
  successStatus: 201,
  body: z.object({ playerId: PlayerIdSchema }),
  response: SignedInSchema.extend({ player: PlayerSchema }),
});

export const getCurrentSession = defineEndpoint({
  method: 'GET',
  path: `${API_PREFIX}/session`,
  access: 'account',
  response: z.object({ session: SessionSchema, player: PlayerSchema.nullable() }),
});

export const deleteCurrentSession = defineEndpoint({
  method: 'DELETE',
  path: `${API_PREFIX}/session`,
  access: 'account',
  response: z.object({ revoked: z.literal(true) }),
});

/** Plays as one of the account's characters; closes the realtime connection of another one. */
export const selectCharacter = defineEndpoint({
  method: 'PUT',
  path: `${API_PREFIX}/session/character`,
  access: 'account',
  body: z.object({ playerId: PlayerIdSchema }),
  response: z.object({ session: SessionSchema, player: PlayerSchema }),
});

/** Stops playing the chosen character (back to the character list). */
export const releaseCharacter = defineEndpoint({
  method: 'DELETE',
  path: `${API_PREFIX}/session/character`,
  access: 'account',
  response: z.object({ session: SessionSchema }),
});
